import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/layout/page-layout'
import RolesTable from '@/components/organisms/roles-table'
import { PermissionsUtils } from '@/utils/permissions.utils'

export const Route = createFileRoute('/_authenticated/roles')({
  component: RolesRoute,
})

function RolesRoute() {
  const { t } = useTranslation()

  if (!PermissionsUtils.hasPermission('roles:read')) return null

  return (
    <PageLayout title={t('rolesPage.title')}>
      <RolesTable />
    </PageLayout>
  )
}
